export const encryptionKey = () => {
  if( window.location.host.indexOf( 'localhost' ) !== -1 ) {
    return 'sowbellY83seated72sTitch';
  } 
  if( window.location.host.indexOf( 'staging' ) !== -1 ) {
    return 'sowbellY83seated72sTitch';
  } 
  return 'engineEr16sWay78globUlar'
}